import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if @enableClicking}}\n  <a href=\"#\" {{fn this.selectForDrag}}>\n    {{yield}}\n  </a>\n{{else}}\n  {{yield}}\n{{/if}}")